import Parse from 'html-react-parser';

function BMP20166(props) {
    let svgCode =
    `<svg width="200" height="168" viewBox="0 0 200 168" fill="none" xmlns="http://www.w3.org/2000/svg">
    <style type="text/css">
    .styledText text {
        ${props.styledText}
    }
    ${props.fontFace}
    </style>
        <rect x="3.5" y="3.5" width="193" height="43" fill="${props.darkFill}" />
        <rect x="3.5" y="59.5" width="193" height="43" fill="${props.darkFill}" />
        <rect x="3.5" y="115.5" width="193" height="43" fill="${props.highlightColour}" />
        <g class="styledText" font-weight="${props.fontExtras.weight}" letter-spacing="${props.fontExtras.space}">
            <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="16.2038" y="33.8867">ENV2</tspan></text>
            <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="16.2038" y="89.8867">ENV2</tspan></text>
            <text fill="${props.fontColour}" font-family="${props.fontName}" font-size="26"><tspan x="47.9682" y="145.887">ENV2</tspan></text>
        </g>
        <g class="styledText" fill="${props.fontColour}" stroke="${props.fontColour}">
            <line x1="24.9286" y1="124" x2="24.9286" y2="150" stroke-width="2"/>
            <line x1="38.9286" y1="137" x2="11.0714" y2="137" stroke-width="2"/>
            <path d="M25 123L30.5673 129H19.4327L25 123Z" />
            <path d="M40 137L33.5714 142.196L33.5714 131.804L40 137Z" />
            <path d="M10 137L16.4286 131.804L16.4286 142.196L10 137Z" />
            <path d="M25 151L19.4327 145L30.5673 145L25 151Z" />
        </g>
    </svg>`

    props.svgReturn(10, svgCode, "bmp00166", 200, 168);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "50px",
        top: "762px",
        left: "320px",
        display: props.display
    }

    const inStyle = {
        marginTop: "-110px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20166;